import { exportAdvancesExcelService } from "../infrastructure/services/exportAdvancesExcelService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { exportAllGuestsExcelUrl } from "@/business/events/infrastructure/constants/urls";
import { exportAdvancesExcelUrl } from "@/business/advance/infrastructure/constants/urls";

export const exportAdvancesExcel = {
  async execute(date: string): Promise<string> {
    return getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(exportAdvancesExcelUrl)
      .replace("{date}", date);
  },
};
